/*
* npm i moment moment-timezone
*/


import moment from "moment-jalaali";
// import momentZone from 'moment-timezone';

// const timeZone = {
//   getRegion() {
//     return momentZone.tz.guess();
//   },
//   timeByZone(input, outFormat = null, inFormat = null) {
//     //not empty input
//     if (!input) return null;

//     //set default out format
//     if (!outFormat) outFormat = 'HH:mm:ss';

//     //set default in format
//     if (!inFormat) inFormat = 'HH:mm:ss';

//     let localeTimeZone = momentZone.tz.guess();
//     return momentZone(input, inFormat).tz(localeTimeZone).format(outFormat)
//   }

// };

const dateTime = {
  install(Vue) {
    Vue.mixin({
      data: () => ({

        momentSet: null,

      }),
      created: function () {
        moment.loadPersian({usePersianDigits: false, dialect: 'persian-modern'});
        this.momentSet = moment();
      },
    });
    Vue.prototype.$isValidDate = function (val = null) {
      let date = moment(val);
      return !!(date.isValid() && (date.format('YYYY') > 1990));
    };
    Vue.prototype.$priceFormatting = function (val = null) {
      const price = parseFloat(val).toFixed(3);
      const result = price.toString();
      return parseFloat(result).toLocaleString();
    };
    Vue.prototype.$statusReplacing = function (val = null) {
      switch (val) {
        case 0:
          return 'غیر فعال'
        case 1:
          return 'فعال'
        case 'waiting':
          return 'در انتظار';
        case 'paid':
          return 'پرداخت شده'
        case 'unpaid':
          return 'پرداخت ناموفق';
        case 'confirmed':
          return "تایید شده"
        case 'cancelled':
          return 'لغو شده'
        case 'cancelled_by_doctor':
          return 'لغو شده توسط دکتر'
        case 'cancelled_by_user':
          return 'لغو شده توسط کاربر'
      }
    };
    Vue.prototype.$weekdayReplacing = function (val = null) {
      switch (val) {
        case 'Sat':
          return 'شنبه';
        case 'Sun':
          return 'یکشنبه';
        case 'Mon':
          return 'دوشنبه';
        case 'Tue':
          return 'سه شنبه';
        case 'Wed':
          return 'چهار شنبه';
        case 'Thu':
          return 'پنجشنبه';
        case 'Fri':
          return 'جمعه';
        default:
          break;
      }
    };
    Vue.prototype.$paymentReplacing = function (val = null) {
      switch (val) {
        case 'online':
          return 'آنلاین (از طریق وبسایت)';
        case 'cash':
          return 'پرداخت نقدی'
        case 'cart_bu_cart':
          return 'کارت به کارت';
        case 'card_reader':
          return "کارت خوان"
      }
    };
    Vue.prototype.$userReplacing = function (val = null) {
        return `${val.first_name} ${val.last_name}`
    };
    Vue.prototype.$subserviceReplacing = function (val = null) {
      switch (val) {
        case 12:
          return 'روکش سرامیکی';
        case 11:
          return 'ارتودنسی'
        case 10:
          return 'ایمپلنت';
        case 9:
          return 'ترمیم دندان'
        case 6:
          return 'ونیر کامپوزیت'
        case 5:
          return 'بلیچینگ'
        case 4:
          return 'درمان ریشه'
        case 3:
          return 'لمینیت دندان'
      }
    };

    Vue.prototype.$getDate = function (input, outFormat = null, inFormat = null) {

      //not empty input
      if (!input) return null;

      //set default out format
      if (!outFormat) outFormat = 'jYYYY/jMM/jDD  -  HH:mm';

      //set default in format
      if (!inFormat) inFormat = 'YYYY-MM-DD HH:mm:ss';

      //return result

      let date = moment(input);
      if (date.isValid() && (date.format('YYYY') > 1990))
        return moment(input, inFormat).format(outFormat);
      else
        return 'invalid'
    };
    Vue.prototype.$getDatePure = function (input, outFormat = null, inFormat = null) {

      //not empty input
      if (!input) return null;

      //set default out format
      if (!outFormat) outFormat = 'jYYYY/jMM/jDD';

      //set default in format
      if (!inFormat) inFormat = 'YYYY-MM-DD';

      //return result

      let date = moment(input);
      if (date.isValid() && (date.format('YYYY') > 1990))
        return moment(input, inFormat).format(outFormat);
      else
        return 'invalid'
    };
    Vue.prototype.$moment = function (val = null) {
      return moment(val)
    };
    Vue.prototype.$getYear = function (outFormat = null) {
      let format = outFormat;
      if (!outFormat)
      format = 'YYYY-MM-DD HH:mm:ss';
      return {
        start: this.momentSet.startOf('jYear').format(format),
        end: this.momentSet.endOf('jYear').format(format),
      }
    };
    Vue.prototype.$getMonth = function (outFormat = null) {
      let format = outFormat;
      if (!outFormat)
        format = 'YYYY-MM-DD HH:mm:ss';
      return {
        start: this.momentSet.startOf('jMonth').format(format),
        end: this.momentSet.endOf('jMonth').format(format),
      }
    };
    // Vue.prototype.$timeZone = timeZone;
  }
};
export default dateTime;

